/* pawty-nb-hero-slider.js
   Vanilla custom element powering sections/pawty-hero-slider.liquid.
   No external libraries. Auto-advances every N ms (default 4000), pauses on
   hover/focus, and respects prefers-reduced-motion by never starting
   autoplay (and stopping it if the preference changes mid-session). */
(function () {
  if (window.customElements && customElements.get('pawty-hero-slider')) return;

  function PawtyHeroSliderFactory() {
    class PawtyHeroSlider extends HTMLElement {
      constructor() {
        super();
        this._index = 0;
        this._timer = null;
        this._handlePause = this._handlePause.bind(this);
        this._handleResume = this._handleResume.bind(this);
        this._handleReduceMotionChange = this._handleReduceMotionChange.bind(this);
      }

      connectedCallback() {
        this.slides = Array.prototype.slice.call(this.querySelectorAll('[data-hero-slide]'));
        this.dots = Array.prototype.slice.call(this.querySelectorAll('[data-hero-dot]'));
        this.prevBtn = this.querySelector('[data-hero-prev]');
        this.nextBtn = this.querySelector('[data-hero-next]');

        if (!this.slides.length) return;

        var initial = this.slides.findIndex(function (slide) {
          return slide.classList.contains('is-active');
        });
        this._index = initial > -1 ? initial : 0;

        this.dots.forEach(function (dot) {
          dot.addEventListener('click', function () {
            var i = parseInt(dot.getAttribute('data-index'), 10);
            this.goTo(i);
            this._restart();
          }.bind(this));
        }, this);

        if (this.prevBtn) {
          this.prevBtn.addEventListener('click', function () {
            this.goTo(this._index - 1);
            this._restart();
          }.bind(this));
        }
        if (this.nextBtn) {
          this.nextBtn.addEventListener('click', function () {
            this.goTo(this._index + 1);
            this._restart();
          }.bind(this));
        }

        this.addEventListener('mouseenter', this._handlePause);
        this.addEventListener('mouseleave', this._handleResume);
        this.addEventListener('focusin', this._handlePause);
        this.addEventListener('focusout', this._handleResume);

        this._reduceMotionQuery = window.matchMedia
          ? window.matchMedia('(prefers-reduced-motion: reduce)')
          : null;
        if (this._reduceMotionQuery) {
          if (this._reduceMotionQuery.addEventListener) {
            this._reduceMotionQuery.addEventListener('change', this._handleReduceMotionChange);
          } else if (this._reduceMotionQuery.addListener) {
            this._reduceMotionQuery.addListener(this._handleReduceMotionChange);
          }
        }

        this._start();
      }

      disconnectedCallback() {
        this._stop();
        this.removeEventListener('mouseenter', this._handlePause);
        this.removeEventListener('mouseleave', this._handleResume);
        this.removeEventListener('focusin', this._handlePause);
        this.removeEventListener('focusout', this._handleResume);
        if (this._reduceMotionQuery) {
          if (this._reduceMotionQuery.removeEventListener) {
            this._reduceMotionQuery.removeEventListener('change', this._handleReduceMotionChange);
          } else if (this._reduceMotionQuery.removeListener) {
            this._reduceMotionQuery.removeListener(this._handleReduceMotionChange);
          }
        }
      }

      get autoplayMs() {
        var raw = parseInt(this.getAttribute('data-autoplay-ms'), 10);
        return isFinite(raw) && raw > 0 ? raw : 4000;
      }

      get prefersReducedMotion() {
        return !!(this._reduceMotionQuery && this._reduceMotionQuery.matches);
      }

      goTo(index) {
        var count = this.slides.length;
        if (!count) return;
        var next = ((index % count) + count) % count;
        if (next === this._index && this.slides[next].classList.contains('is-active')) return;

        var current = this.slides[this._index];
        if (current) current.classList.remove('is-active');
        if (this.dots[this._index]) this.dots[this._index].classList.remove('is-active');

        this._index = next;

        this.slides[this._index].classList.add('is-active');
        if (this.dots[this._index]) this.dots[this._index].classList.add('is-active');
      }

      _start() {
        if (this.prefersReducedMotion) return;
        if (this.slides.length < 2) return;
        this._stop();
        this._timer = window.setInterval(
          function () {
            this.goTo(this._index + 1);
          }.bind(this),
          this.autoplayMs
        );
      }

      _stop() {
        if (this._timer) {
          window.clearInterval(this._timer);
          this._timer = null;
        }
      }

      _restart() {
        this._stop();
        this._start();
      }

      _handlePause() {
        this._stop();
      }

      _handleResume() {
        this._start();
      }

      _handleReduceMotionChange() {
        if (this.prefersReducedMotion) {
          this._stop();
        } else {
          this._start();
        }
      }
    }

    return PawtyHeroSlider;
  }

  customElements.define('pawty-hero-slider', PawtyHeroSliderFactory());
})();
